import { MantineThemeOverride } from '@mantine/core';

export type IndicatorTheme = NonNullable<MantineThemeOverride['components']>['Indicator'];

export const Indicator: IndicatorTheme = {
  // todo: define
};
